import { AGGWTransport, AGTransport, } from "@agrigate/shared/lib/rpc/clients";
import { rpcClient } from "@lorefnon/ts-json-rpc/lib/client";
// Max 5 requests in-flight at once — queues the rest.
// Lower this if the DB connection pool starts showing pressure.
const withConcurrencyLimit = (transport, limit = 5) => {
    let running = 0;
    const queue = [];
    const original = transport.request.bind(transport);
    transport.request = (...args) => new Promise((resolve, reject) => {
        const attempt = () => {
            running++;
            original(...args)
                .then(resolve, reject)
                .finally(() => {
                var _a;
                running--;
                (_a = queue.shift()) === null || _a === void 0 ? void 0 : _a();
            });
        };
        running < limit ? attempt() : queue.push(attempt);
    });
    return transport;
};
export const getClients = (opts, serviceType = "backend", interceptors) => {
    const transports = {
        backend: withConcurrencyLimit(new AGTransport(Object.assign({}, opts)), 5),
        gateway: withConcurrencyLimit(new AGGWTransport(Object.assign({}, opts)), 5),
    };
    const clientOpts = (name) => (Object.assign({ transport: transports[serviceType], meta: { name } }, interceptors));
    return {
        orderAggrs: rpcClient(clientOpts("reporting-api/order-aggregates")),
        userAggrs: rpcClient(clientOpts("reporting-api/user-aggregates")),
        shipmentAggrs: rpcClient(clientOpts("reporting-api/shipment-aggregates")),
        clusterAggrs: rpcClient(clientOpts("reporting-api/cluster-aggregates")),
        filters: rpcClient(clientOpts("filters")),
        bgJobs: rpcClient(clientOpts("reporting-api/background-jobs")),
        dashMetrics: rpcClient(clientOpts("reporting-api/dashboard-metric")),
        insuranceAggrs: rpcClient(clientOpts("reporting-api/insurance-aggregates")),
        bookingAggrs: rpcClient(clientOpts("reporting-api/booking-aggregates")),
        marketplaceAggrs: rpcClient(clientOpts("reporting-api/marketplace-aggregates")),
        soilTestingAggrs: rpcClient(clientOpts("reporting-api/soil-testing-aggregates")),
        aiTokenAggrs: rpcClient(clientOpts("reporting-api/ai-token-usage")),
        investorReports: rpcClient(clientOpts("reporting-api/investor-reports")),
        reportingMetrics: rpcClient(clientOpts("reporting-api/reporting-metrics")),
    };
};
//# sourceMappingURL=clients.js.map